import type { ObjectCustomerType } from '@econtractor/types';

type ObjectCustomerTextField = Exclude<keyof ObjectCustomerType, 'vatEnabled'>;

const TEXT_FIELDS: ObjectCustomerTextField[] = [
    'personType',
    'fullName',
    'edrpouOrIpn',
    'vatNumber',
    'iban',
    'bank',
    'phone',
    'email',
    'legalAddress',
    'representativeName',
    'representativePosition',
];

export const mergeCustomerFromAi = (
    current: ObjectCustomerType,
    parsed: Partial<ObjectCustomerType>,
): ObjectCustomerType => {
    const next: ObjectCustomerType = { ...current };

    if (parsed.personType === 'legal' || parsed.personType === 'individual') {
        next.personType = parsed.personType;
    }

    TEXT_FIELDS.forEach((field) => {
        if (field === 'personType') return;
        const value = parsed[field];
        if (typeof value === 'string' && value.trim()) {
            next[field] = value.trim();
        }
    });

    if (typeof parsed.vatEnabled === 'boolean') {
        next.vatEnabled = parsed.vatEnabled;
    }

    if (!next.vatEnabled) {
        next.vatNumber = '';
    }

    return next;
};

export const hasCustomerAiValues = (customer: Partial<ObjectCustomerType>): boolean =>
    TEXT_FIELDS.some((field) => Boolean(String(customer[field] || '').trim())) || customer.vatEnabled === true;
